var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSrLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 380 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 216.424L124.843 182.911C138.568 201.608 167.43 217.124 202.978 217.124C231.839 217.124 252.251 206.895 252.251 185.732C252.251 132.116 92.4543 178.324 98.4426 83.4335H98.7952C134.696 128.581 305.051 81.6662 305.051 183.964C305.051 231.94 264.926 262.978 201.927 262.978C151.595 262.978 109.714 243.928 90 216.417L90 216.424ZM201.927 9.01443C253.669 9.01443 284.64 25.237 305.404 52.4021L270.914 85.5614C255.778 68.2785 238.18 54.8762 201.927 54.8762C167.782 54.8762 151.948 65.4581 151.948 82.3876C151.948 86.2683 153.006 90.5025 154.41 92.9694V93.3228C139.626 91.909 102.667 85.9148 102.667 61.2239C102.667 36.533 138.568 9.01443 201.927 9.01443ZM328.285",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrLogo);
export default __webpack_public_path__ + "static/media/SR Logo.b777a3b9981c0e9bb4860b39702eb58b.svg";
export { ForwardRef as ReactComponent };